// extracted by mini-css-extract-plugin
export default {"container":"Home_container__mhZ51","body":"Home_body__Jc-kR"};